import { Snackbar } from "@material-ui/core"
import { Alert } from "@material-ui/lab"
import React from "react"

export type Severity = "success" | "error" | "warning" | "info"

export const useSnackbar = () => {
  const [alert, setAlert] = React.useState({
    open: false,
    message: "",
    severity: "success" as Severity,
    timeout: 5000,
  })

  const showMessage = (
    message: string,
    severity: Severity = "success",
    timeout?: number
  ) => {
    setAlert({
      open: true,
      message,
      severity,
      timeout: timeout ? timeout : 5000,
    })
  }

  const handleClose = () => {
    setAlert({ ...alert, open: false })
  }

  const SnackbarComponent = () => (
    <Snackbar
      open={alert.open}
      autoHideDuration={alert.timeout}
      onClose={handleClose}
      anchorOrigin={{ horizontal: "right", vertical: "top" }}
    >
      <Alert variant="standard" onClose={handleClose} severity={alert.severity}>
        {alert.message}
      </Alert>
    </Snackbar>
  )

  return {
    showMessage,
    SnackbarComponent,
  }
}
